import { memo, useMemo } from 'react'
import { OIChart, OiChartScaleSide } from './OIChart'
import { OI_CHART_META_INFO, oiChartDataEqual, OiChartRow } from './oiChartData'
import { SegmentInfo } from '../participantOpenInterest'

type Props = {
    chartData: OiChartRow[]
    showOI: boolean
    replayKey: number
    compactBars?: boolean
    scaleSide?: OiChartScaleSide
    showLegend?: boolean
    showTooltip?: boolean
    onHoverRow?: (row: OiChartRow | null) => void
}

const OiAnalysisChartPanel = ({ chartData, showOI, replayKey, compactBars, scaleSide, showLegend, showTooltip, onHoverRow }: Props) => {
    const segmentInfo: SegmentInfo = useMemo(
        () => ({
            metaInfo: OI_CHART_META_INFO,
            data: chartData,
            leftScaleData: [],
            displayName: '',
        }),
        [chartData]
    )

    return (
        <OIChart
            segmentInfo={segmentInfo}
            showOI={showOI}
            replayKey={replayKey}
            compactBars={compactBars}
            scaleSide={scaleSide}
            showLegend={showLegend}
            showTooltip={showTooltip}
            onHoverRow={onHoverRow}
        />
    )
}

export default memo(OiAnalysisChartPanel, (prev, next) => {
    if (
        prev.showOI !== next.showOI ||
        prev.replayKey !== next.replayKey ||
        prev.compactBars !== next.compactBars ||
        prev.scaleSide !== next.scaleSide ||
        prev.showLegend !== next.showLegend ||
        prev.showTooltip !== next.showTooltip
    ) {
        return false
    }
    return oiChartDataEqual(prev.chartData, next.chartData)
})
